// src/services/emailService.js
import emailjs from '@emailjs/browser';

export const sendEmail = async (formData) => {
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

  const templateParams = {
    from_name: formData.name,
    from_phone: formData.phone,
    service: formData.service,
    message: `Callback request for ${formData.service} from <span class="math-inline">\{formData\.name\} \(</span>{formData.phone})`,
  };

  try {
    const response = await emailjs.send(serviceId, templateId, templateParams, publicKey);
    return response;
  } catch (error) {
    console.error("Error sending email:", error);
    throw error; // Re-throw for handling in the component
  }
};